import { PresetTag } from '@components/display';
import { useAppTranslation } from '@hooks';
import { getRiskLevelValueKey } from '@utils/getRiskLevelValueKey';
import { TRiskLevelState } from '@definitions';
import { useNavigate } from 'react-router';
import { useContext } from 'react';
import {
  Button,
  SpaceCompact,
  colors,
  Icon,
  LayoutContainer,
  Paragraph,
  Row,
  Space,
} from 'common-components';

import { RiskContext } from '@/context';

type RiskTopBarPropsType = {
  docName?: string
  riskScore?: number
  riskLevel?: TRiskLevelState
};
const TopBarRisk = ({ docName, riskLevel, riskScore }: RiskTopBarPropsType) => {
  const { translate } = useAppTranslation();
  const navigate = useNavigate();

  const { currentPage, onPageChange, isFirstPage, isLastPage } = useContext(RiskContext);

  return (
    <LayoutContainer
      style={{
        height: 72,
        padding: '0 16px',
        justifyContent: 'center',
        borderBottom: `1px solid ${colors.gray200}`,
        flex: 'unset',
      }}
    >
      <Row style={{ width: '100%' }} justify={'space-between'}>
        <Space size={16} align={'center'}>
          <Button size="sm" onClick={() => navigate(-1)}>
            <Icon icon="FlipBackward" size={20} />
          </Button>
          <Paragraph color={colors.gray700} style={{ marginBottom: 0, fontSize: 16, fontWeight: 500 }}>
            {translate('risk.riskOverviewTitle', {
              name: docName,
            })}
          </Paragraph>
          <PresetTag preset="risk-level" state={riskLevel}>
            {translate(`risk.levelStates.${getRiskLevelValueKey(riskLevel)}`)}
          </PresetTag>
          <PresetTag preset="risk-score" state={riskScore}>
            {riskScore ? `${riskScore}%` : '-'}
          </PresetTag>
        </Space>
        <Space size={10} align={'center'}>
          <SpaceCompact>
            <Button
              onClick={() => onPageChange(currentPage - 1)}
              disabled={isFirstPage}
              iconLeft={'ChevronLeft'}
            />
            <Button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={isLastPage}
              iconLeft={'ChevronRight'}
            />
          </SpaceCompact>
        </Space>
      </Row>
    </LayoutContainer>
  );
};

export default TopBarRisk;
